import { Body1, UIHeading1, Button } from '@cian/ui-kit';
import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.css';
import { useIsMounted } from '../../hooks/useIsMounted';

export interface IMortgageRateHikeBannerProps {
  onClick?: () => void;
}

export const MortgageRateHikeBanner = ({ onClick }: IMortgageRateHikeBannerProps) => {
  // Фон баннера грузим после гидрации, чтобы он не отнимал канал у LCP-картинки на первом экране
  const isMounted = useIsMounted();

  return (
    <div className={styles['container']}>
      <div className={styles['content-container']}>
        <div className={styles['text-container']}>
          <UIHeading1 color="text-on-bright-default">Семейные квартиры на прежних условиях</UIHeading1>
          <Body1 color="text-on-bright-default">До 1 октября есть время</Body1>
        </div>

        <Button onClick={onClick} theme="inverted">
          Буду знать
        </Button>
      </div>

      <div
        className={clsx(styles['image'], isMounted && styles['image--with-image'])}
        data-testid="BannerImage"
        data-image-loaded={isMounted}
        aria-hidden="true"
      />
    </div>
  );
};
